import React from "react"
import { LoadableP5 } from "./loadable";
import Sketch from "./wave-sketch";

function P5Component(attributes) {
    if (typeof window !== "undefined") {
    return <LoadableP5 sketch={Sketch} attributes={attributes} />
    }
    else {
        return null;
    }
}

export default P5Component;